module.exports = __webpack_public_path__ + "img/rune-arcane.aaaa7f74.png";